type CountryType = Record<string, Record<string, string>[]>

export enum COUNTRY_DATA_KEY {
  COUNTRY_SELECTION_DATA = 'COUNTRY_SELECTION_DATA',
  PHONE_NUMBER_DATA = 'PHONE_NUMBER_DATA',
  LANGUAGE_SELECTION_DATA = 'LANGUAGE_SELECTION_DATA',
}

export const COUNTRY_SELECTION_DATA = [
  {
    text: 'countryCodes.TR',
    flag: 'TR',
    value: 'TR',
  },
  {
    text: 'countryCodes.DE',
    flag: 'DE',
    value: 'DE',
  },
  {
    text: 'countryCodes.AT',
    flag: 'AT',
    value: 'AT',
  },
  {
    text: 'countryCodes.PL',
    flag: 'PL',
    value: 'PL',
  },
  {
    text: 'countryCodes.BA',
    flag: 'BA',
    value: 'BA',
  },
  {
    text: 'countryCodes.BE',
    flag: 'BE',
    value: 'BE',
  },
  {
    text: 'countryCodes.BG',
    flag: 'BG',
    value: 'BG',
  },
  {
    text: 'countryCodes.CH',
    flag: 'CH',
    value: 'CH',
  },
  {
    text: 'countryCodes.CZ',
    flag: 'CZ',
    value: 'CZ',
  },
  {
    text: 'countryCodes.DK',
    flag: 'DK',
    value: 'DK',
  },
  {
    text: 'countryCodes.EE',
    flag: 'EE',
    value: 'EE',
  },
  {
    text: 'countryCodes.ES',
    flag: 'ES',
    value: 'ES',
  },
  {
    text: 'countryCodes.FI',
    flag: 'FI',
    value: 'FI',
  },
  {
    text: 'countryCodes.FR',
    flag: 'FR',
    value: 'FR',
  },
  {
    text: 'countryCodes.GR',
    flag: 'GR',
    value: 'GR',
  },
  {
    text: 'countryCodes.HR',
    flag: 'HR',
    value: 'HR',
  },
  {
    text: 'countryCodes.HU',
    flag: 'HU',
    value: 'HU',
  },
  {
    text: 'countryCodes.IE',
    flag: 'IE',
    value: 'IE',
  },
  {
    text: 'countryCodes.IT',
    flag: 'IT',
    value: 'IT',
  },
  {
    text: 'countryCodes.LT',
    flag: 'LT',
    value: 'LT',
  },
  {
    text: 'countryCodes.LU',
    flag: 'LU',
    value: 'LU',
  },
  {
    text: 'countryCodes.LV',
    flag: 'LV',
    value: 'LV',
  },
  {
    text: 'countryCodes.MD',
    flag: 'MD',
    value: 'MD',
  },
  {
    text: 'countryCodes.ME',
    flag: 'ME',
    value: 'ME',
  },
  {
    text: 'countryCodes.MK',
    flag: 'MK',
    value: 'MK',
  },
  {
    text: 'countryCodes.NL',
    flag: 'NL',
    value: 'NL',
  },
  {
    text: 'countryCodes.NO',
    flag: 'NO',
    value: 'NO',
  },
  {
    text: 'countryCodes.PT',
    flag: 'PT',
    value: 'PT',
  },
  {
    text: 'countryCodes.RO',
    flag: 'RO',
    value: 'RO',
  },
  {
    text: 'countryCodes.RS',
    flag: 'RS',
    value: 'RS',
  },
  {
    text: 'countryCodes.SE',
    flag: 'SE',
    value: 'SE',
  },
  {
    text: 'countryCodes.SI',
    flag: 'SI',
    value: 'SI',
  },
  {
    text: 'countryCodes.SK',
    flag: 'SK',
    value: 'SK',
  },
  {
    text: 'countryCodes.UK',
    flag: 'GB',
    value: 'GB',
  },
]

export const LANGUAGE_SELECTION_DATA = [
  {
    flag: 'TR',
    value: 'tr',
    text: 'TR',
  },
  {
    flag: 'GB',
    value: 'en',
    text: 'EN',
  },
  {
    flag: 'DE',
    value: 'de',
    text: 'DE',
  },
]

export const PHONE_NUMBER_DATA = [
  {
    flag: 'TR',
    value: 'TR',
    text: 'countryCodes.TR',
    prefix: '+90',
  },
  {
    flag: 'DE',
    value: 'DE',
    text: 'countryCodes.DE',
    prefix: '+49',
  },
  {
    flag: 'AT',
    value: 'AT',
    text: 'countryCodes.AT',
    prefix: '+43',
  },
  {
    flag: 'PL',
    value: 'PL',
    text: 'countryCodes.PL',
    prefix: '+48',
  },
]

export const AUTH_ONBOARDING_DATA = [
  {
    flag: 'TR',
    value: 'TR',
    text: 'countryCodes.TR',
    prefix: '+90',
  },
  {
    flag: 'DE',
    value: 'DE',
    text: 'countryCodes.DE',
    prefix: '+49',
  },
  {
    flag: 'PL',
    value: 'PL',
    text: 'countryCodes.PL',
    prefix: '+48',
  },
]

export const COUNTRIES: CountryType = {
  COUNTRY_SELECTION_DATA,
  PHONE_NUMBER_DATA,
  LANGUAGE_SELECTION_DATA,
}

export const getCountries = (key: string, t: (arg: string) => void) => {
  return COUNTRIES[key].map((item: { value?: string; text?: string; prefix?: string }) => ({
    ...item,
    text: t(item.text || ''),
  }))
}

export const getAuthCountries = (t: (arg: string) => void) => {
  return AUTH_ONBOARDING_DATA.map((item: { value?: string; text?: string; prefix?: string }) => ({
    ...item,
    text: t(item.text || ''),
  }))
}

export const makeContactData = (
  t: (arg: string) => void,
  countries: { id: string; countryCode: string }[]
) => {
  return countries.map(item => ({
    flag: item?.id,
    value: item?.id,
    text: t(`countryCodes.${item?.id}`),
    prefix: `+${item?.countryCode}`,
  }))
}
